"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactSelectMe = _interopRequireDefault(require("react-select-me"));
require("react-select-me/lib/ReactSelectMe.css");
var _CoreInput = require("../../utilities/CoreInput");
var _Icon = _interopRequireDefault(require("../../elements/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DropdownIndicator = _ref => {
  let {
    color
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "arrow_drop_down",
    containerSize: "medium",
    size: 1,
    color: color,
    className: "dd__dropDownIcon"
  });
};
DropdownIndicator.propTypes = {
  color: _propTypes.default.string
};
const SelectMe = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  let {
    defaultValue
  } = props;
  const {
    value: valueArg
  } = props;
  if (!defaultValue) {
    defaultValue = props.isMultiSelect ? [] : null;
  }
  let selectValue = defaultValue || valueArg;
  if (!props.isMultiSelect) {
    const selectedOptions = props.options.find(option => selectValue?.value === option.value);
    selectValue = selectedOptions;
  }
  if (props.isMultiSelect && selectValue) {
    const selectedOptions = props.options.filter(option => selectValue.some(item => item.value === option.value));
    selectValue = selectedOptions;
  }
  const [value, setValue] = (0, _react.useState)(selectValue);
  const onDropdownChange = selectedValue => {
    setValue(selectedValue);
    props.onChange(selectedValue);
  };
  const options = props.options || [];
  const classNames = (0, _classnames.default)({
    'is-danger': props.error
  });
  return /*#__PURE__*/_react.default.createElement("span", {
    className: props.maxListHeight > 0 ? 'customHeight' : ''
  }, /*#__PURE__*/_react.default.createElement(_reactSelectMe.default, {
    ref: ref,
    className: (0, _classnames.default)('core-select-container', props.className, classNames) || undefined,
    classNamePrefix: "core-select",
    closeMenuOnSelect: !props.isMultiSelect,
    multiple: props.isMultiSelect,
    disabled: props.isDisabled || props.disabled,
    placeholder: props.placeholder,
    listHeight: props.maxListHeight > 0 ? props.maxListHeight * 42 : props.maxHeight,
    iconRenderer: DropdownIndicator,
    isOpened: props.maxListHeight > 0 ? true : undefined,
    forbidPhantomSelection: true,
    options: options,
    value: value,
    searchable: false,
    onChange: onDropdownChange
  }));
});
SelectMe.displayName = 'Select';
SelectMe.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.array]),
  isMultiSelect: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  iconLeft: _propTypes.default.string,
  iconRight: _propTypes.default.string,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  maxHeight: _propTypes.default.number,
  maxListHeight: _propTypes.default.number,
  color: _propTypes.default.string,
  options: _propTypes.default.array,
  onChange: _propTypes.default.func,
  error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
};
SelectMe.defaultProps = {
  value: null,
  isMultiSelect: false,
  isDisabled: false,
  disabled: false,
  label: '',
  placeholder: 'Select an Option',
  options: [],
  onChange: () => {}
};
var _default = exports.default = (0, _CoreInput.withFieldControl)(SelectMe, {
  validationIcon: false
});
//# sourceMappingURL=Select.js.map